import React from 'react';
import {config} from "../config";

const ChangeSeasonerModel = ({chainCode, itemId, seasonerForm, weight, waste}) => {
    return {
        step: config.processingSteps.STEP_09,
        source: {
            chainCode: chainCode,
        },
        destination: {
            itemId: itemId,
            seasonerId: (seasonerForm.find(item => item.chainCode === chainCode))?.seasonerId,
            waste: waste || [],
            weight: parseInt(weight)
        },
    }
};

export default ChangeSeasonerModel;
